export { default } from './DetailedCarFixedPreviewPanel';
